import baseFind from "./_internal/_baseFind.js";

export default baseFind("querySelector");
